module.exports = __webpack_public_path__ + "static/Spa-6798cb5f91c6611ec9846664f23b7ff0.jpg";